export default [
  {
    header: 'Warehouse',
    icon: 'PackageIcon',
    i18n: 'Warehouse',
    items: [
      {
        url: '/warehouse/products',
        name: 'Products',
        slug: 'products',
        icon: 'StarIcon',
        i18n: 'Products'
      },
      {
        url: '/warehouse/brands',
        name: 'Brands',
        slug: 'brands',
        icon: 'TagIcon',
        i18n: 'Brands'
      }
    ]
  },
  {
    header: 'Sales',
    icon: 'ShoppingCartIcon',
    i18n: 'Sales',
    items: [
      {
        url: '/sales/clients',
        name: 'Clients',
        slug: 'clients',
        icon: 'HeartIcon',
        i18n: 'Clients'
      },
      {
        url: '/sales/orders',
        name: 'Orders',
        slug: 'orders',
        icon: 'FileIcon',
        i18n: 'Orders'
      },
      {
        url: '/sales/users',
        name: 'Users',
        slug: 'users',
        icon: 'UsersIcon',
        i18n: 'Users'
      }
    ]
  },
  {
    header: 'General',
    icon: 'SettingsIcon',
    i18n: 'General',
    items: [
      {
        url: '/settings/content',
        name: 'Content',
        slug: 'content',
        icon: 'GlobeIcon',
        i18n: 'Content'
      },
      {
        url: '/settings/posts',
        name: 'Posts',
        slug: 'posts',
        icon: 'AlignCenterIcon',
        i18n: 'Posts'
      }
    ]
  }
]

